const numDigits = 7;
const minValue = 10 ** (numDigits - 1);
const maxValue = 10 ** numDigits - minValue;

/**
 * Generate a 7 digit decimal number from the 32 digit hex ID by taking some
 * modulus of the decimal representation of the full ID. The lower bound ensures
 * the resulting number will never be fewer digits than desired.
 * Note: There is a non-zero chance two vendors would end up with the same
 * numeric ID. For markets with less than a few hundred vendors, this is a small
 * chance. E.g. with 200 vendors it's about 0.2% chance, however with 425
 * vendors it grows to 1% and by 1400 vendors it is over a 10% chance.
 */
export default function getShortVendorId(vendorId: string): string {
  // The largest amount of hex digits that can safely be represented in JS
  // number type is 13.
  let hexVal = vendorId.slice(-13);
  let numericVal = parseInt(hexVal, 16);
  let result = (numericVal % maxValue) + minValue;
  return result.toString();
}
